"use client";

import Link from "next/link";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

export default function Hero() {
  const slides = [
    "https://emagyl.s3.eu-north-1.amazonaws.com/banner.webp",
  ];

  return (
    <section className="container">
      <div className="row g-0" style={{ minHeight: 260 }}>
        <div className="col-12 position-relative p-0">
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            spaceBetween={0}
            slidesPerView={1}
            style={{ height: "100%" }}
          >
            {slides.map((src, idx) => (
              <SwiperSlide key={idx}>
                <Link href="/toate-produsele" className="d-block">
                  <img
                    src={src}
                    alt={`Promo ${idx + 1}`}
                    className="w-100"
                    style={{
                      display: "block",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      minHeight: 260,
                    }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
